


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Button from '@/components/common/elements/Button.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Pagination from '@/components/common/modules/Pagination.vue';
import CheckBoxTable from '@/components/common/modules/CheckBoxTable.vue';
import { chipItems } from '@/constants/components/constructionList';
import { Items } from '@/services/hexabase/types';

@Component({
  components: { Button, SingleText, Pagination, CheckBoxTable }
})
export default class OrderList extends Vue {
  @Prop({
    default: () => ({
      currentPage: 1,
      totalPage: 1,
      visible: 1
    })
  })
  private pageInfo?: { [k: string]: number };

  // 一覧表示の合計件数
  private totalResults = 0;
  // 現在表示中の最小件数値
  private minDisplayedResults = 0;
  // 現在表示中の最大件数値
  private maxDisplayedResults = 0;
  // 選択アイテム
  private selectedItem: Array<Items> = [];
  // 一覧内のチップ背景色 (色、カラム名)
  private chipItems = chipItems;
  // データテーブルに表示するColumnリスト
  @Prop({ default: () => [] })
  private colums?: [];
  // データテーブルに表示するデータリスト
  @Prop({ default: () => [] })
  private data?: [];
  // データテーブルのカスタムソート関数
  @Prop()
  private customSort?: Function;
  // ステータス更新動作キャッチ用フラグ
  // 変更を感知したら内部選択プロパティを初期化
  @Prop({ default: false })
  private flush!: boolean;

  mounted() {
    // Todo: API経由で取得して、表示用に加工する必要があるかも
    this.totalResults = 1;
    this.minDisplayedResults = 1;
    this.maxDisplayedResults = 4;
  }

  /**
   * ページネーションの押下ページ番号をEmit
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void} Emit
   */
  @Emit('pagenaviAction')
  private pagenaviAction(response: any) {
    return response;
  }

  /**
   * 明細詳細ボタン押下時の画面遷移
   * @param {any} clickRecord - レコード情報
   * @returns {void} - ルーティング
   */
  private toDetailPage(value: any) {
    this.$router.push('/construction/constructionedit/' + value.i_id);
  }

  private createPageNation(pageInfo: { [k: string]: number }, dataCount: number) {
    const initialNum = 1;
    const start =
      pageInfo.currentPage > initialNum
        ? (pageInfo.currentPage - initialNum) * pageInfo.perPage + initialNum
        : initialNum;
    const end = start - 1 + dataCount;
    return `全${pageInfo.totalItem}件中 ${start}件〜${end}件を表⽰`;
  }
}
